import { Colors } from "../../utils/colors";
import RectangleButton from "../Buttons/RectangleButton";
import StandardBorderedContainer from "../Containers/StandardBorderedContainer";

type ConnectStripeDashboardBannerProps = {
  title: string;
  description: string;
  onConnectPress: () => void;
};

// Persistent dashboard banner shown to a promoter/payment collector who hasn't
// connected Stripe yet, so it's clear without needing to click into a modal first
export const ConnectStripeDashboardBanner = (
  props: ConnectStripeDashboardBannerProps
) => {
  const { title, description, onConnectPress } = props;

  const styles = {
    sectionContainer: {
      backgroundColor: Colors.WHITE,
      padding: 14,
      borderRadius: 14,
    },
  };

  return (
    <StandardBorderedContainer containerStyles={styles.sectionContainer}>
      <div className="AlignedRowSpaced">
        <div>
          <div className="EventDashboardContentHeader">{title}</div>
          <div className="EventDashboardContentDescription">{description}</div>
        </div>
        <RectangleButton
          buttonLabel="Connect Stripe"
          onPress={onConnectPress}
          altColor={Colors.BLACK}
          altTextColor={Colors.WHITE}
          containerStyles={{
            padding: "14px 12px",
            width: "fit-content",
            whiteSpace: "nowrap",
          }}
        />
      </div>
    </StandardBorderedContainer>
  );
};
